/**
 * 걸음수 서버 연동 (TO_USR_WALK_HIST).
 *
 * 걸음수 원본은 삼성 헬스가 갖고 있고, 서버는 그걸 받아 보관한다.
 * 삼성 헬스 조회는 네이티브(브릿지)가 하고 서버 전송은 웹이 한다 —
 * 그래야 JWT 가 웹뷰 밖으로 나가지 않는다.
 */
import axiosApi from './daonAxios';

const authOption = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem('jToken')}`,
    },
});

/** "2026-08-06" -> "20260806" (DB REC_DE 는 varchar(8)) */
export const toRecDe = (dateStr) => String(dateStr).replace(/-/g, '');

/** "20260806" -> "2026-08-06" */
export const fromRecDe = (recDe) =>
    `${recDe.slice(0, 4)}-${recDe.slice(4, 6)}-${recDe.slice(6, 8)}`;

/** 가장 최근 걸음수 1건. 홈 화면의 걸음수 행에서 쓴다. */
export const getCurrentWalk = async () => {
    const res = await axiosApi.get('/walk/currentWalk', authOption());
    return res.data?.result ?? null;
};

/** 걸음수 전체 기록. 서버는 날짜당 최신 1건만, 최신순으로 준다. */
export const getWalkList = async () => {
    const res = await axiosApi.get('/walk/list', authOption());
    return res.data?.result ?? [];
};

/**
 * 걸음수 저장. 같은 날짜가 이미 있으면 서버가 갱신한다.
 *
 * 여러 날짜를 한 번에 보낸다 — 최초 연동 시 30일 소급이 호출 1번으로 끝난다.
 * walkDstnc 는 DB 가 numeric(5,1) 이라 소수점 1자리까지만 보관된다.
 *
 * @param {Array<{recDe, steps, cnsumCalor, walkDstnc}>} walkList
 */
export const saveWalk = async (walkList) => {
    if (!walkList || walkList.length === 0) return false;

    const res = await axiosApi.post(
        '/walk',
        { walkList },
        { ...authOption(), noLoading: true }, // 백그라운드 동기화라 전역 로딩을 띄우지 않는다
    );
    return res.data?.result === true;
};
